module.exports = __webpack_public_path__ + "static/lemon-281978771340b5d2f9bdc13d6515eea7.svg";